import styled from 'styled-components/macro';
export const FasletWrapperStyled = styled.div `
  position: relative;

  faslet-app {
    position: absolute;
  }
`;
